import React, { FC } from 'react';
import { ProductLabel } from 'scripts/types/procuct';

export const ProductCardLabel: FC<{label: ProductLabel}> = ({ label }) => {
  const labelLayout = label.icon ? (<img className="icon" title={label.title} src={label.icon} />) : label.title;
  const style = label.icon
    ? { background: label.color }
    : { background: `${label.color}1A`, color: label.color };
  if (!label.description && !label.link) {
    return (
      <div
        className="product-card__label"
        style={style}
      >
        {labelLayout}
      </div>
    )
  } else {
    return (
      <button
        className="product-card__label"
        aria-label={label.title}
        style={style}
        data-label-id={label.id}
        aria-expanded="false"
      >
        {labelLayout}
      </button>
    )
  }
}